import * as yup from 'yup'
import { EMAIL_REGEX, PAGE_STORE_ORDERS, PASSWORD_REGEX } from 'utils/constants'
import { PAGE_ACCESS_KEY_PREFIX } from 'components/userManagement/utils'

const PASSWORD_MESSAGE =
  'Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.'

// schema for login page
export const loginSchema = yup
  .object()
  .shape({
    email: yup
      .string()
      .required('Email is required field')
      .matches(EMAIL_REGEX, 'Please Enter a valid email.'),
    password: yup.string().required('Password is required field'),
  })
  .required()

// schema for  forgot password
export const forgotPasswordSchema = yup
  .object()
  .shape({
    email: yup
      .string()
      .required('Email is required field')
      .matches(EMAIL_REGEX, 'Please Enter a valid email.'),
  })
  .required()

export const createPasswordSchema = yup.object().shape({
  password: yup.string().matches(PASSWORD_REGEX, PASSWORD_MESSAGE).required(),
  cpassword: yup
    .string()
    .required('Confirm Password is required field')
    .oneOf([yup.ref('password'), ''], 'Both Password must be same'),
})

export const addUserSchema = yup
  .object()
  .shape({
    firstName: yup.string().trim().required('First Name is required field'),
    lastName: yup.string().trim().required('Last Name is required field'),
    empId: yup.string().required('Employee ID is required field'),
    email: yup
      .string()
      .trim()
      .matches(EMAIL_REGEX, 'Please Enter a valid email.')
      .required('Email is required field'),
    password: yup.string().matches(PASSWORD_REGEX, PASSWORD_MESSAGE).required(),
    isActive: yup.boolean(),
    store: yup
      .string()
      .typeError('Invalid Store')
      .test('non-null', 'Store is Required', (value) => {
        return value !== 'NO_STORES'
      })
      .when(PAGE_ACCESS_KEY_PREFIX + PAGE_STORE_ORDERS.id, (type, schema) => {
        if (typeof type[0] === 'boolean')
          return schema.required(
            'Store is required when Store Order is selected in Page Access',
          )
        return schema
      }),
    role: yup.string(),
  })
  .required()

// Will use the same schema as AddUser overiding the password field
export const updateUserSchema = addUserSchema.shape({
  password: yup
    .string()
    .optional()
    .trim()
    .test('isValidPassword', PASSWORD_MESSAGE, (value) => {
      // Allow null or validate against the regex
      return value === '' || PASSWORD_REGEX.test(value as string)
    }),
  empId: yup.string().optional(),
  email: yup.string().optional(),
})

export type UpdateUserType = yup.InferType<typeof updateUserSchema>
export type AddUserType = yup.InferType<typeof addUserSchema>
